<!--
    校区管理-云盘资源管理
    功能：展示云盘资源管理的数据列表
    组件：旧版本
-->
<template>
  <div class="school-center-padding" :class="[route === '/cloud' ? 'cloud' : '', 'courseware']" v-if="show">
    <div class="breadcrumb">
      <span v-for="(item, index) in currentList" :key="index" @click="navBar(item)">
        {{ item.name === '' ? '我的云盘' : item.name }}
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <div class="btn">
      <div
        class="btn-upload"
        v-if="$permissions('school_course_cloud_upload')"
      >
        <input
          type="file"
          :size="schoolCenter ? '' : 'small'"
          @change="upload"
          name="file"
          id="file"
          accept="/*"
          ref="fileInput"
        >
        <el-button class="btn-gray" :size="schoolCenter ? '' : 'small'">
          <i class="el-icon-upload"/>
          上传
        </el-button>
      </div>
      <el-button
        v-if="$permissions('school_course_cloud_create')"
        type="primary"
        :size="schoolCenter ? '' : 'small'"
        @click="createDir"
      >
        <i class="el-icon-plus"/>
        新建
      </el-button>
    </div>
    <AppSearch :order="{ type: 'id', name: 'desc'}" :search-arr="searchArr" @search-name="searchData"/>
    <el-table :data="list" v-loading="loading">
      <el-table-column
        label="文件名称"
        width="300px">
        <template slot-scope="scope">
          <p class="dir" @click="godir(scope.row)">
            <i :class="[
            'icon',
             scope.row.type === 'd' ?
             scope.row.type :
             scope.row.resources && scope.row.resources.mime && scope.row.resources.mime !== '' ?
              [...resourcesMime(scope.row.resources.mime)] : '']"></i>
            {{ scope.row.name }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        v-for="column in columns"
        v-if="!column.show"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :formatter="column.formatter"
      />
      <el-table-column
        label="操作"
        width="250px"
        class="orgin-btn">
        <template slot-scope="scope">
          <template v-if="schoolCenter">
            <div v-if="scope.row.type === 'd'">
              <el-link
                v-if="$permissions('school_course_cloud_copy')"
                @click="operation(scope.row, 'copy')"
              >复制</el-link>
              <i
                v-if="$permissions('school_course_cloud_copy') && $permissions('school_course_cloud_move')"
                class="icon-splite"
              >|</i>
              <el-link
                v-if="$permissions('school_course_cloud_move')"
                @click="operation(scope.row, 'move')"
              >移动</el-link>
              <i
                v-if="$permissions('school_course_cloud_move') && $permissions('school_course_cloud_delete')"
                class="icon-splite"
              >|</i>
              <el-link
                v-if="$permissions('school_course_cloud_delete')"
                @click="del(scope.row)"
              >删除</el-link>
            </div>
            <div v-else>
              <el-link
                v-if="$permissions('school_course_cloud_download')"
                @click="download(scope.row)"
              >下载</el-link>
              <i
                v-if="$permissions('school_course_cloud_download') && $permissions('school_course_cloud_perview')"
                class="icon-splite"
              >|</i>
              <el-link
                v-if="$permissions('school_course_cloud_perview')"
                @click="pereview(scope.row)"
              >预览</el-link>
              <i
                v-if="$permissions('school_course_cloud_download') || $permissions('school_course_cloud_perview')"
                class="icon-splite"
              >|</i>
              <el-dropdown trigger="hover">
                <span class="el-link el-link--default">
                  更多 <i class="el-icon-caret-bottom el-icon--right"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="$permissions('school_course_cloud_copy')"
                    class="clearfix">
                    <span
                      class="dropdownSpan"
                      @click="operation(scope.row, 'copy')">复制</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="$permissions('school_course_cloud_move')"
                    class="clearfix">
                    <span
                      class="dropdownSpan"
                      @click="operation(scope.row, 'move')">移动</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="$permissions('school_course_cloud_delete')"
                    class="clearfix">
                    <span
                      class="dropdownSpan"
                      @click="del(scope.row)">删除</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
          <template v-else>
            <div v-if="scope.row.type === 'd'">
              <el-button size="small" @click="operation(scope.row, 'copy')" v-if="$permissions('school_course_cloud_copy')">复制</el-button>
              <el-button size="small" @click="operation(scope.row, 'move')" v-if="$permissions('school_course_cloud_move')">移动</el-button>
              <el-button size="small" type="danger" plain @click="del(scope.row)" v-if="$permissions('school_course_cloud_delete')">删除</el-button>
            </div>
            <div v-else>
              <el-button
                v-if="$permissions('school_course_cloud_download')"
                size="small"
                @click="download(scope.row)"
              >下载</el-button>
              <el-button
                v-if="$permissions('school_course_cloud_perview')"
                size="small"
                @click="pereview(scope.row)"
              >预览</el-button>
              <el-dropdown trigger="hover">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-caret-bottom el-icon--right"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="$permissions('school_course_cloud_copy')"
                    class="clearfix">
                    <span
                      class="dropdownSpan"
                      @click="operation(scope.row, 'copy')">复制</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="$permissions('school_course_cloud_move')"
                    class="clearfix">
                    <span
                      class="dropdownSpan"
                      @click="operation(scope.row, 'move')">移动</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="$permissions('school_course_cloud_delete')"
                    class="clearfix">
                    <span
                      class="dropdownSpan"
                      @click="del(scope.row)">删除</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="新建文件夹"
      :visible.sync="formDialogVisible"
      width="500px">
      <el-form
        :rules="rules"
        ref="form"
        :model="formData"
        label-width="125px"
        @submit.native.prevent>
        <el-form-item label="文件夹名称：" prop="dirname">
          <el-input v-model="formData.dirname" maxlength="20" placeholder="请输入文件夹名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDir">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="nodeTitle.name"
      :visible.sync="editDialogVisible"
      width="600px">
      <el-tree
        v-if="editDialogVisible"
        :props="props"
        :load="loadNode"
        @node-click="checkDir"
        lazy>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitfileDir(nodeTitle.type)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="showPreview"
      class="preview"
      title="预览"
      :visible.sync="showPreview"
      width="60%">
      <iframe :src="previewUrl"></iframe>
    </el-dialog>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  import initCos from "../../utils/upload/tencentCos";

  export default {
    name: "Courseware",
    inject: ['reload'],
    mixins: [list],
    data() {
      return {
        list: [],
        show: true,
        formData: {
          dirname: ''
        },
        rules: {
          dirname:[
            { required: true, message: '请输入文件夹名称', trigger: 'blur' }
          ]
        },
        formDialogVisible: false,
        loading: false,
        current: '/',
        nodeCurrent: '/',
        checkCurrent: '', // 选中的文件夹
        checkFileName: '', // 选中的文件名
        currentList: [],
        editDialogVisible: false,
        nodeTitle: {
          name: '',
          type: ''
        },
        props: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
        },
        fileFormData: {
          school_id: '', // 学校id
          staff_id: '', // 老师id
          src_full_path: '', // 原始路径
          tar_full_path: '', // 目标路径
        },
        isCreated: true,
        route: this.$route.path,
        showPreview: false,
        previewUrl: "", // 预览url
        // 内嵌h5云盘携带参数
        cloud: {
          user_id: this.$route.query.user_id, // 用户id
          user_name: this.$route.query.user_name, // 用户名
          school_id: this.$route.query.school_id, // 校区id
          app_id: this.$route.query.app_id, // app_id
          token: this.$route.query.token, // token
          api_url: this.$route.query.api_url, // api地址
          from: this.$route.query.from // 访问来源 C++: windows
        },
        schoolCenter: this.$store.state.from === 'schoolCenter',
      }
    },
    computed: {
      user() {
        return this.route === '/cloud' ? { id: this.cloud.user_id } : this.$store.state.user;
      },
      school() {
        return this.route === '/cloud' ? { id: this.cloud.school_id } : this.$store.state.choicesSchool;
      },
      apiUrl() {
        // if (this.user.school_id === this.school.id) {
          return `/api/disk/list?staff_id=${this.user.id}&school_id=${this.school.id}`;
        // }
      },
      columns() {
        return [
          {
            label: '大小',
            formatter: (row) => row.resources ? this.$setting.getFileSize(row.resources.size) : '--'
          },
          {
            label: '类型',
            formatter: (row) => row.type === 'd' ? '文件夹' : row.resources ? row.resources.ext : '--'
          },
          { prop: 'created_at', label: '上传时间', width: '160px'  },
          { prop: 'staff.name', label: '上传者' }
        ];
      },
      searchArr() {
        const column = [
          { prop: 'name', label: '文件名称' }
        ];
        return [
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      }
    },
    watch: {
      user() {
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
          this.load();
        })
      }
    },
    created() {
      if (this.route === '/cloud') {
        this.$token.set(this.cloud.token);
        this.$store.state.appId = this.cloud.app_id;
        this.$store.state.apiUrl  = `${this.$checkHttp()}${this.cloud.api_url}`;
        this.$http.get(`${this.$checkHttp()}${this.cloud.api_url}/api/user`)
          .then(res => {
            this.$store.commit('initUser', res); // 初始化用户信息
          })
          .catch((err) => {
            this.$message.error(err.message);
          })
      }
      this.currentList.push({
        id: 0,
        path: '/',
        name: ''
      });
      this.load();
    },
    methods: {
      // 云盘目录结构
      loadNode(node, resolve) {
        if (node.level === 0) {
          return resolve([{ name: '我的云盘', path: '/', type: 'index' }]);
        }
        this.nodeCurrent = node.level <= 1 ? '/' : `${node.data.path === '/' ? '' : node.data.path}/${node.data.name}`;
        this.apiUrl && this.$http.get(`${this.apiUrl}&current=${this.nodeCurrent}`)
          .then((res) => {
            const data = [];
            res.disk.forEach(item => {
              if (item.type === 'd') {
                data.push({ name: item.name, path: item.path })
              }
            });
            resolve(data);
          })
          .catch((err) => {
            console.log(err.message);
          });
      },
      checkDir(nodeObj, node) {
        if (node.data.type && node.data.type === 'index') {
          this.checkCurrent = '/';
        } else {
          this.checkCurrent = `${node.data.path === '/' ? '' : node.data.path}/${node.data.name}`;
        }
        console.log('11', node.data)
      },
      resourcesMime(val) {
        return [val.split('/')[0], val.split('/')[1].replace(/\./g, "_")];
      },
      load(type) {
        if (this.user.id && this.school.id && this.apiUrl) {
          this.loading = true;
          const searchName = type ? `&${type[0]}=${type[1]}` : '';

          this.$http.get(`${this.apiUrl}&current=${this.current}${searchName}`)
            .then((res) => {
              this.list = res.disk;
            })
            .catch((err) => {
              console.log(err.message);
            }).finally(() => {
              this.loading = false;
            });
        }
      },
      createDir() {
        this.formDialogVisible = true;
        this.formData = { dirname: '' };
      },
      // 复制 移动
      operation(row, type) {
        this.editDialogVisible = true;
        this.nodeTitle = {
          name: type === 'copy' ? '复制文件' : '移动文件',
          type: type
        };
        this.checkFileName = row.name;
        this.fileFormData = {
          school_id: this.school.id, // 学校id
          staff_id: this.user.id, // 老师id
          src_full_path: `${ row.path === '/' ? '' : row.path }/${row.name}`, // 原始路径
          tar_full_path: '', // 目标路径
        };
      },
      // 文件操作提交
      submitfileDir(){
        if (this.isCreated) {
          const type = this.nodeTitle.type;
          const data = {
            ...this.fileFormData,
            tar_full_path: `${this.checkCurrent}/${this.checkFileName}`
          };
          if (type === 'copy') {
            this.isCreated = false;
            this.$http.post('/api/disk/copy', data)
              .then(() => {
                this.isCreated = true;
                this.$message.success('复制成功！');
                this.editDialogVisible = false;
                this.load();
              })
              .catch((err) => {
                this.isCreated = true;
                this.$message.error(err.message);
              });
          } else if (type === 'move') {
            this.isCreated = false;
            this.$http.put('/api/disk/move', data)
              .then(() => {
                this.isCreated = true;
                this.$message.success('移动成功！');
                this.editDialogVisible = false;
                this.load();
              })
              .catch((err) => {
                this.isCreated = true;
                this.$message.error(err.message);
              });
          }
        }
      },
      // 搜索条件
      searchData(val) {
        this.load(val[0].split(':'));
      },
      // 新建目录
      submitDir() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const data = {
              staff_id: this.user.id,
              current: this.current,
              dirname: this.formData.dirname,
              school_id: this.school.id
            };
            if(this.isCreated) {
              this.isCreated = false;
              this.$http.post('/api/disk/mkdir', data)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('新建成功！');
                  this.formDialogVisible = false;
                  this.load();
                })
                .catch((err) => {
                  this.isCreated = true;
                  if (err.errors.dirname){
                    this.$message.error('文件夹名称已存在，请重新修改文件夹名称！');
                  } else {
                    this.$message.error(err.message);
                  }
                });
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 创建文件
      upload(e) {
        // 选择文件
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        // const fileType = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'pptm', 'mp3', 'mp4', 'jpg', 'jpeg', 'png', 'bmp', 'txt'];
        const fileType = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'pptm'];
        const arr = files[0].name.split('.');
        const isTrue = fileType.find((type) => type === arr[arr.length - 1]);
        if (isTrue) {
          this.touchFile(files[0]);
        } else {
          this.$message.error('当前只支持doc/docx/pdf/ppt/pptx/pptm格式，请上传正确文件格式的文件!');
        }
      },
      touchFile(file) {
        const that = this;
        initCos(file, this.school.id, res => {
          const cos = res.cos;
          const _key = `${res.resource_dir}${res.md5}.${res.type}`; /* 必须 */
          cos.putObject({
            Bucket: res.Bucket, /* 必须 */
            Region: res.Region, /* 存储桶所在地域，必须字段 */
            Key: _key,
            StorageClass: 'STANDARD',
            Body: file, // 上传文件对象
            onProgress: function(progressData) {
              console.log('onProgress', JSON.stringify(progressData));
            }
          }, function(err, data) {
            if (data) {
              const param = {
                current: that.current, // 当前所在路径
                school_id: that.school.id, // 学校ID
                staff_id: that.user.id, // 教师ID
                localname: res.name, // 上传时的文件名
                remotepath: _key, // 远程文件名
                md5: res.md5, // 文件md5值
                etag: data.ETag // 腾讯云上传后获得的etag
              };
              // 创建文件
              that.$http.post('/api/disk/touch', param)
                .then((res) => {
                  that.$message({
                    type: 'success',
                    message: '上传文件成功！'
                  });
                  setTimeout(() => {
                    that.load();
                    that.$refs.fileInput.value = '';
                  }, 2000)
                })
                .catch((err) => {
                  that.$refs.fileInput.value = '';
                  if (err.errors.localname){
                    that.$message.error('文件名已存在或文件名含有特殊字符，请重新上传！');
                  } else {
                    that.$message.error(err.message);
                  }
                });
            } else {
              that.$refs.fileInput.value = '';
              that.$message.error(err);
            }
          });
        })
      },
      // 下载文件
      download(row) {
        this.getBlob(row.resources.url, (blob) => {
          this.saveAs(blob, row.name);
        });
      },
      getBlob(url, cb) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
          if (xhr.status === 200) {
            cb(xhr.response);
          }
        };
        xhr.send();
      },
      saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          const link = document.createElement('a');
          const body = document.querySelector('body');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          // fix Firefox
          link.style.display = 'none';
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }
      },
      // 预览文件
      pereview(row) {
        this.showPreview = true;
        const onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx'];
        const isOffice = onlineViewType.find((type) => type === row.resources.ext);
        if (isOffice) {
          // 是否为office文件
          this.previewUrl = `https://view.officeapps.live.com/op/view.aspx?src=${row.resources.url}` // microsoft office online sdk
        } else {
          this.previewUrl = row.resources.url
        }
      },
      // 云盘导航
      navBar(row) {
        if (!this.loading) {
          const len = this.currentList.findIndex(item => item.id === row.id);
          const newRouter = [];
          this.currentList.forEach((item, index) => {
            if (len + 1 > index) {
              newRouter.push(item);
            }
          });
          this.currentList = newRouter;
          this.current = `${row.path === '/' ? '' : row.path }/${row.name}`;
          this.load();
        }
      },
      // 进入文件夹
      godir(row) {
        if (row.type === 'd') {
          this.current = `${row.path === '/' ? '' : row.path}/${row.name}`;
          this.currentList.push(row);
          this.load();
        } else {
          const viewType = ['doc', 'docx', 'ppt', 'pptx', 'pdf'];
          const isFile = viewType.find((type) => type === row.resources.ext);
          if (this.cloud.from === 'windows' && isFile) {
            this.$confirm('是否选择文件?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              const data = {
                name: row.name, // 文件名
                url: row.resources.url // 文件地址
              }
              window.SelectCloudFile(JSON.stringify(data)); // 触发给应用选择文件
            })
          }
        }
      },
      // 删除文件
      del(row) {
        this.$confirm('是否删除文件?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.delete(`/api/disk/remove?school_id=${this.school.id}&staff_id=${this.user.id}&full_path=${row.path === '/' ? '' : row.path}/${row.name}`)
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.load();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.courseware {
  position: relative;

  &.cloud {
    background-color: #fff;
    padding: 24px 32px;
    min-height: 200px;
  }
  .app-search-index {
    display: block;
    text-align: right;
    margin-top: 20px;
  }
  .breadcrumb {
    height: 71px;
    line-height: 71px;
    font-size: 18px;
    font-weight: 500;
    color: #303133;

    span {
      cursor: pointer;

      &:last-child {
        i {
          display: none;
        }
      }
    }
  }

  i.icon {
    display: inline-block;
    vertical-align: sub;
    width: 18px;
    height: 21px;
    &.d {
      width: 23px;
      height: 19px;
      background: url("../../assets/images/icon_dir.png") no-repeat;
      background-size: 100% 100%;
    }
    &.vnd_openxmlformats-officedocument_wordprocessingml_document {
      background: url("../../assets/images/doc.png") no-repeat;
      background-size: 100% 100%;
    }
    &.vnd_openxmlformats-officedocument_presentationml_presentation {
      background: url("../../assets/images/ppt.png") no-repeat;
      background-size: 100% 100%;
    }
    &.pdf {
      background: url("../../assets/images/pdf.png") no-repeat;
      background-size: 100% 100%;
    }
    &.image {
      background: url("../../assets/images/image.png") no-repeat;
      background-size: 100% 100%;
    }
    &.video {
      background: url("../../assets/images/mp4.png") no-repeat;
      background-size: 100% 100%;
    }
    &.audio {
      background: url("../../assets/images/mp3.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .dir {
    display: inline-block;
    cursor: pointer;
    margin: 0;

    &:hover{
      color: var(--color-primary);
    }
  }
  .el-tree >>> .el-tree-node:focus>.el-tree-node__content {
    background: rgb(255, 247, 232);
  }
  .preview {
    iframe {
      width: 100%;
      height: 65vh;
      display: block;
      border: none;
    }
  }
  .btn {
    display: flex;
    float: left;
  }
  .btn-upload {
    position: relative;
    margin-right: 20px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;

      &::-webkit-file-upload-button {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
      }
    }
    .btn-gray {
      color: #909399;
    }
  }
  .app-search-index {
    float: right;
    margin: 0 0 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Courseware/index.vue